export default {
    data() {
        return {};
    },

    computed: {
        /* 多语言属性 */
        $lang({ language }) {
            let en = language.charAt(0).toUpperCase() + language.substring(1);
            let str = language === 'zh' ? '' : en;
            return str;
        },
        /* 多语言属性 */
        $lang2({ language }) {
            return language === 'zh' ? '' : `_${language}`;
        },
        language() {
            return this.$store.state.language;
        },
        userData() {
            return this.$store.state.userData;
        },
    },
    methods: {}
};
